export default {
    data() {
        return {
            starList: [],
            // letterList: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
            letterList: [],
            paddingTop: 30,
            top: 90,
            selected: 0
        }
    },

    watch: {

    },

    mounted() {
        // 事件监听滚动条
        window.addEventListener("scroll", this.watchScroll);
    },

    destroyed() {
        // 移除事件监听
        window.removeEventListener("scroll", this.watchScroll);
    },


    created() {
        this.getStarList();
    },

    methods: {
        // 首字母筛选
        scrollAnchorPoint(item,index) {
            this.selected = index;
            document.querySelector("#"+item).scrollIntoView(true);
        },

        // 获取明星列表
        getStarList() {
            const loading = this.$loading({
                target: '#star',
                text: '加载中...',
            });
            this.$post('api.php/Home/starList').then(res => {
                if(res.status == 1) {
                    let data = res.data || {};

                    this.letterList = Object.keys(data.list);

                    this.starList = data.list;

                }
            }).finally(() => {
                loading.close();
            })
        },

        watchScroll() {
            // 滚动的距离
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;

            let offsetTop = document.querySelector('#star-index').offsetTop;

            this.top = scrollTop;

            if (scrollTop < 144) {
                this.top = 90
            }

            if (scrollTop > 144) {
                this.paddingTop = 145;
            } else {
                this.paddingTop = 30;
            }

            this.letterList.map((item,index) => {

                let el = document.getElementById(item);

                // console.log(el.offsetTop - scrollTop)

                if(el.offsetTop - scrollTop < 60 && el.offsetTop - scrollTop > 0) {
                    this.selected  = index
                };

            });

        }
    }
}
